import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';


 function __getDataCollectionStatsReportForOffice (officeId) {
     return axios.get(utilityService.getApiUrl('report/officedata/' + officeId),
         {
             headers: utilityService.getHeaders()
         }
     );
 }

export const reportingUnitsService = {
	getDataCollectionStatsForOffice: (officeId) => __getDataCollectionStatsReportForOffice(officeId),
};